export { SocialIframeSource, iframeSizeDesktop, iframeSizeMobile } from './merchantSection.constants';
